const config = {
  // API_BASE_URL: "https://s3test.cludocloud.com/Api",
  // API_BASE_URL: "https://jac-board-2026-api.cludocloud.com",
  // API_BASE_URL2: "https://jac-board-2026-api.cludocloud.com",
  // API_BASE_URL: "https://d-jac-10.cludocloud.com/Api",
  // API_BASE_URL2 : "https://d-jac-10.cludocloud.com/Api",
  // OTP: "123456",
  // CLASS_9_BACKDOOR_PHONE_NUMBER : "8617850151",
  // CLASS_9_BACKDOOR_EMAIL : "sumit@cludotechnology.in"


  // API_BASE_URL: "https://board-ten-api.cludocloud.com",
  // API_BASE_URL: "https://board-nine-api.cludocloud.com",
  // API_BASE_URL2: "https://board-ten-api.cludocloud.com",
  // API_BASE_URL: "https://board-twelve-api.cludocloud.com",
  // API_BASE_URL: "https://board-eleven-api.cludocloud.com",
  // API_BASE_URL2: "https://board-twelve-api.cludocloud.com",



  //  API_BASE_URL: "https://localhost:7197",
  //  API_BASE_URL2: "https://localhost:7197",

  //  API_BASE_URL: "https://api-board-ten.jacexamonline.com",
  //  API_BASE_URL: "https://api-board-nine.jacexamonline.com",
  //  API_BASE_URL2: "https://api-board-ten.jacexamonline.com",
  // API_BASE_URL: "https://api-board-twelve.jacexamonline.com",
  API_BASE_URL: "https://api-board-eleven.jacexamonline.com",
  API_BASE_URL2: "https://api-board-twelve.jacexamonline.com",

  // IA_LINK: "http://localhost:5173",
  //  IA_LINK: "http://jac-ia-practical.cludocloud.com",
  // IA_LINK_logout: "http://jac-ia-practical.cludocloud.com/api",

  //  IA_LINK: "https://jac-iap-twelve.jacexamonline.com",
  //  IA_LINK_logout: "https://api-jac-twelve-ia.jacexamonline.com",

  // IA_LINK: "https://jac-iap-ten.jacexamonline.com",
  // IA_LINK_logout: "https://api-jac-ten-ia.jacexamonline.com",

  // IA_LINK: "http://jac-iap-eleven.jacexamonline.com",
  // IA_LINK_logout: "https://api-jac-ia-eleven.jacexamonline.com",
  
  // IA_LINK: "http://jac-iap-nine.jacexamonline.com",
  // IA_LINK_logout: "https://api-jac-ia-nine.jacexamonline.com",
  

SECRET_KEY: "2EzxyBb2JRyHdS4bsibNenBQWQTAGIbt",
  // BASE_URL_1: "/class-nine",
  BASE_URL_1: "",
  BASE_URL_1_STATUS: "OFF",
  // BASE_URL_2: "/class-ten",
  BASE_URL_2: "",
  BASE_URL_2_STATUS: "OFF",
  // BASE_URL_3: "/class-eleven",
  BASE_URL_3: "",
  BASE_URL_3_STATUS: "OFF",
  // BASE_URL_4: "/class-twelve",
  BASE_URL_4: "",
  BASE_URL_4_STATUS: "OFF",
  BASE_URL_ON_OFF: "ON",

  ENCRYPT_PASSWORD: "deFuTYUtYa",
  LATERAL_STATUS_10: "OFF",
  LATERAL_STATUS_12: "OFF",
};
export default config;
